/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';

/**
 * 
 * @export
 * @interface ProductList
 */
export interface ProductList {
    /**
     * 
     * @type {string}
     * @memberof ProductList
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductList
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ProductList
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductList
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ProductList
     */
    externalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductList
     */
    supplierId: string;
    /**
     * 
     * @type {Status}
     * @memberof ProductList
     */
    status: Status;
    /**
     * 
     * @type {Date}
     * @memberof ProductList
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProductList
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the ProductList interface.
 */
// @ts-ignore
export function instanceOfProductList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "supplierId" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

// @ts-ignore
export function ProductListFromJSON(json: any): ProductList {
    return ProductListFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductList {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'description': json['description'],
        'externalCode': !exists(json, 'external_code') ? undefined : json['external_code'],
        'supplierId': json['supplier_id'],
        'status': StatusFromJSON(json['status']),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

// @ts-ignore
export function ProductListToJSON(value?: ProductList | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
        'description': value.description,
        'external_code': value.externalCode,
        'supplier_id': value.supplierId,
        'status': StatusToJSON(value.status),
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
    };
}

